jQuery(document).ready(function () {
  
  jQuery(".btn--submit-mobile").click(function (e){
    e.preventDefault();
    let button = jQuery(this);
    let header = jQuery('.site-header');
    let form = jQuery('.product__form__wrapper');
    let addToCart = form.find('.btn--submit[name="add"]');
    let variations = form.find('.variant-wrapper[data-option="option1"]');
    let offset_height = form.offset().top - header.height();
    jQuery('html, body').animate({
        scrollTop: offset_height
    }, 500);
  });

  jQuery(document).on("change", '.variant-input', function (e) {
    let $this = jQuery(this);
    let addToCart = jQuery('.btn--submit[name="add"]');
    let button = jQuery('.btn--submit-mobile');
    button.removeAttr('disabled');
    if ( addToCart.attr('disabled') ) {
      button.attr('disabled', 'disabled');
    }
  });

  jQuery(document).scroll(function () {
    let y = $(this).scrollTop();
    let height = jQuery(window).height();
    let offset = y + height;
    let button = jQuery('.btn--submit-mobile');
    let addToCart = $('.btn--submit[name="add"]').offset().top;
    if ( (offset < addToCart) || (y > addToCart)) {
        button.show();
    } else {
        button.hide();
    }
  });

  function startCountdown() {
      const targetHour = 15;
      const targetMinute = 30;
      const targetSecond = 0;
  
      function updateTimer() {
        const now = new Date();
        const offset = now.getTimezoneOffset();
        now.setMinutes( now.getMinutes() + offset + 60 );
      
        const targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), targetHour, targetMinute, targetSecond);
        
        let hours = 0;
        let minutes = 0;
        let seconds = 0;

        let dayOfWeek = now.getDay();
        let days = 24;
      
        if (now > targetTime) {
          
          if ( dayOfWeek === 5 ) {
            targetTime.setDate(targetTime.getDate() + 3);
            days *= 3;
          } else if ( dayOfWeek === 6 ) {
            targetTime.setDate(targetTime.getDate() + 2);
            days *= 2;
          } else {
            targetTime.setDate(targetTime.getDate() + 1);
          }
          
        }
      
        let timeDifference = targetTime - now;

        hours = Math.floor((timeDifference % (1000 * 60 * 60 * days)) / (1000 * 60 * 60));
        minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('timer').innerHTML = 
            (hours < 10 ? '' : '') + hours + "hrs " + 
            (minutes < 10 ? '0' : '') + minutes + "min";
      }
  
      updateTimer();
      setInterval(updateTimer, 1000);
  }
  
  startCountdown();
  
});
 